import { MutableRefObject, useEffect } from "react"

const useDisableScroll = (ref?: MutableRefObject<HTMLElement>) => {
  useEffect(() => {
    const scrollableElement = ref?.current ?? document.querySelector("body")
    if (scrollableElement?.style) {
      scrollableElement.style.overflow = "hidden"
    }

    return () => {
      if (scrollableElement?.style) {
        scrollableElement.style.overflow = "auto"
      }
    }
  })
}

export default useDisableScroll
